import './components/footer'
import './components/form'
import './components/formhcp'
import './components/internation-tel'
import './components/smarty-autocomplete'
import "./components/map"
// console.log('APP JS LOADED');